import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Input, Form, Button} from 'antd';
import UserDetailsWrapper from './styles/userdetails.style';

import * as TherapistActions from '../../actions/therapist';
import * as AuthUtils from '../../utils/auth';

const validateMessages = {
	required: '${label} is required!',
};

class UserDetails extends Component {
	constructor(props) {
		super(props);
	}

	onChangeStatus = (status) => {
		const { currentUser, therapistRoom, dispatch } = this.props;
		dispatch(TherapistActions.changeUserStatus({mobileNumber: currentUser.mobileNumber, status}, therapistRoom))
	}

	render() {
		const { currentUser } = this.props;
		return (
			<UserDetailsWrapper>
			<div className="userDetailsComponent">
				<header>
					<h1>Logged in as</h1>
					<div className="name">{currentUser.firstName + " " + currentUser.lastName}</div>
					<div className="phone">+{currentUser.mobileNumber}</div>
				</header>
				<div className="dropdownMenu">
					
					<h1>YOUR VIDEO ROOM STATUS</h1>
						<Form  name="nest-messages" validateMessages={validateMessages}>
							<ul>
								<li>
									<div className="list-content">
										<h1>Available</h1>
										<Form.Item>
											<Button className="button available" type="primary" htmlType="submit" onClick={() => this.onChangeStatus("Available")}>
											set
											</Button>
										</Form.Item>
									</div>
								</li>
								<li>
									<div className="list-content">
										<h1>On another call</h1>
										<Form.Item>
											<Button className="button on-other-call" type="primary" htmlType="submit" onClick={() => this.onChangeStatus("On Another Call")}>
											set
											</Button>
										</Form.Item>
									</div>
									<div className="note">
										This status is added by default when you are on a call
									</div>
								</li>
								<li>
									<div className="list-content">
										<h1>Busy</h1>
										<Form.Item>
											<Button className="button busy" type="primary" htmlType="submit" onClick={() => this.onChangeStatus("Busy")}>
											set
											</Button>
										</Form.Item>
									</div>
									{/* <div className="message-text">
										<Form.Item name={['user', 'busy-message']} label="" rules={[{ required: true }]}>
											<Input.TextArea placeholder="Add an optional message to your busy status" />
										</Form.Item>
									</div> */}
								</li>
							</ul>
							<footer>
								<Form.Item>
									<Button className="logoutbtn" type="primary" htmlType="submit" onClick={() => AuthUtils.removeAuthCookie()}>Logout</Button>
								</Form.Item>
							</footer>
						</Form>
				</div>
				
			</div>
			{/* <div className="userprofile_mask"></div> */}
			</UserDetailsWrapper>
		  ) 
	}
}

export default connect(
	state => state
)(UserDetails);
